module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/donate-273.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/contribution/donate.md
// module id = 717
// module chunks = 440